import type { MarketVariants } from '@/lib/i18n'

export type Slide7BridgeCopy = {
  headline: string
}

export const copy: MarketVariants<Slide7BridgeCopy> = {
  US: {
    headline: "Now, let's see it in action.",
  },
  ar: {
    headline: 'والآن، لنرَ ذلك عملياً.',
  },
}
